import { projectClient } from '../../client/client';

export const erx = {
  allergySearch: projectClient('/erx/allergy/search').get,
  medicationSearch: projectClient('/erx/medication/search').get,
  syncPatient: projectClient('/erx/sync-patient/{patientId}').post,
};
